module.exports = __webpack_public_path__ + "img/xy.a050fdc2.gif";